export var ImageGalleryActionType;
(function (ImageGalleryActionType) {
    ImageGalleryActionType["ADD_IMAGE_GALLERY"] = "ADD_IMAGE_GALLERY";
    ImageGalleryActionType["ADD_IMAGE_LIST_GALLERY"] = "ADD_IMAGES_LIST_GALLERY";
    ImageGalleryActionType["CLEAT_ALL_DATA_IMAGE_GALLERY"] = "CLEAT_ALL_DATA_IMAGE_GALLERY";
    ImageGalleryActionType["DELETE_IMAGE"] = "DELETE_IMAGE";
    ImageGalleryActionType["SET_IMAGE_URL"] = "SET_IMAGE_URL";
    ImageGalleryActionType["SEND_IMAGE_REQUEST"] = "SEND_IMAGE_REQUEST";
})(ImageGalleryActionType || (ImageGalleryActionType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/imageGalleryActionType.ts
// module id = 292
// module chunks = 50